export default __webpack_public_path__ + "static/media/gift-card.3977a132.gif";